import { Parameter } from "@/calculator/shared/Classes/ParameterClass";

export class ParameterForm extends Parameter {
  constructor(parameter) {
    parameter.values = parameter.values.filter((option) => !option.hidden);
    super(parameter);
  }
}
